"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSankeyModalWelcome = exports.OpenSankeyModalShortcut = exports.OpenSankeyMenus = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const d3 = __importStar(require("d3"));
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_bootstrap_1 = require("react-bootstrap");
const types_1 = require("./types");
const SankeyConvert_1 = require("./SankeyConvert");
const file_saver_1 = __importDefault(require("file-saver"));
const SankeyUtils_1 = require("./SankeyUtils");
const fa_1 = require("react-icons/fa");
const SankeyUtils_2 = require("./SankeyUtils");
const SankeyLoad_1 = __importDefault(require("./SankeyLoad"));
const SankeyMenuConfiguration_1 = require("./SankeyMenuConfiguration");
// import ModalPreference from './SankeyMenuPreferences'
// import { ModalStyleLink, ModalStyleNode } from './SankeyMenuStyles'
const SankeyMenuDialogs_1 = require("./SankeyMenuDialogs");
/**
 * Variable that define the Menu element, it's variable and function
 *
 * @type {{ data: any; set_data: any; right_menu: any; settings_edition: any; settings_edition_node_tags: any; settings_edition_link_tags: any; settings_edition_data_tags: any; ... 39 more ...; launch: any; }}
 */
const MenuPropTypes = {
    t: prop_types_1.default.func.isRequired,
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    default_sankey_data: prop_types_1.default.func.isRequired,
    logo: prop_types_1.default.string.isRequired,
    logo_terriflux: prop_types_1.default.string.isRequired,
    logo_width: prop_types_1.default.number,
    app_name: prop_types_1.default.string.isRequired,
    button_ref: prop_types_1.default.shape({ current: prop_types_1.default.instanceOf(HTMLLabelElement) }).isRequired,
    accordion_ref: prop_types_1.default.shape({ current: prop_types_1.default.instanceOf(HTMLDivElement) }).isRequired,
    selected_node: prop_types_1.default.shape({ current: prop_types_1.default.shape(types_1.SankeyNodePropTypes).isRequired }).isRequired,
    example_menu: prop_types_1.default.element,
    // portfolio_menu: PropTypes.element,
    formations_menu: prop_types_1.default.element,
    url_prefix: prop_types_1.default.string.isRequired,
    nav_item_active: prop_types_1.default.string.isRequired,
    mode_selection: prop_types_1.default.shape({ current: prop_types_1.default.string.isRequired }).isRequired,
    style_to_apply: prop_types_1.default.string.isRequired,
    set_style_to_apply: prop_types_1.default.func.isRequired,
    callback: prop_types_1.default.func.isRequired,
    show_load: prop_types_1.default.bool.isRequired,
    set_show_load: prop_types_1.default.func.isRequired,
    processing: prop_types_1.default.bool.isRequired,
    setProcessing: prop_types_1.default.func.isRequired,
    failure: prop_types_1.default.bool.isRequired,
    setFailure: prop_types_1.default.func.isRequired,
    not_started: prop_types_1.default.bool.isRequired,
    setNotStarted: prop_types_1.default.func.isRequired,
    result: prop_types_1.default.string.isRequired,
    setResult: prop_types_1.default.func.isRequired,
    path: prop_types_1.default.string.isRequired,
    launch: prop_types_1.default.func.isRequired,
    configurations_menus: prop_types_1.default.arrayOf(prop_types_1.default.element.isRequired).isRequired,
    show_nav: prop_types_1.default.bool.isRequired,
    set_show_nav: prop_types_1.default.func.isRequired,
    show_excel_dialog: prop_types_1.default.bool.isRequired,
    set_show_excel_dialog: prop_types_1.default.func.isRequired,
    show_apply_layout: prop_types_1.default.bool.isRequired,
    set_show_apply_layout: prop_types_1.default.func.isRequired,
    show_save_json: prop_types_1.default.bool.isRequired,
    set_show_save_json: prop_types_1.default.func.isRequired,
    showPreference: prop_types_1.default.bool.isRequired,
    setShowPreference: prop_types_1.default.func.isRequired,
    show_publish_dialog: prop_types_1.default.bool.isRequired,
    set_show_publish_dialog: prop_types_1.default.func.isRequired,
    menus: prop_types_1.default.arrayOf(prop_types_1.default.element.isRequired).isRequired,
    set_welcome_text: prop_types_1.default.func.isRequired,
    show_modalTemplate: prop_types_1.default.bool.isRequired,
    set_show_modalTemplate: prop_types_1.default.func.isRequired,
    cardsTemplate: prop_types_1.default.element.isRequired,
    token: prop_types_1.default.bool.isRequired,
    useNavigate: prop_types_1.default.func.isRequired,
    external_modal: prop_types_1.default.arrayOf(prop_types_1.default.element.isRequired).isRequired,
    menu_banner: prop_types_1.default.object.isRequired,
    loginOut: prop_types_1.default.func.isRequired,
    unsetTokens: prop_types_1.default.func.isRequired,
    // modalShortcut:PropTypes.element.isRequired,
    min_width_and_height: prop_types_1.default.func.isRequired,
    set_user_scale: prop_types_1.default.func.isRequired,
    name_user: prop_types_1.default.string.isRequired
};
const clickSaveSVG = () => {
    const svg = window.d3.select(' .opensankey#svg-container svg');
    svg.selectAll('.sankey-tooltip').remove();
    svg.selectAll('text[visibility=hidden]').remove();
    svg.style('border', '0px');
    svg.select('#grid').style('opacity', '0');
    const html = svg.attr('title', 'test2')
        .attr('version', 1.1)
        .attr('xmlns', 'http://www.w3.org/2000/svg')
        .node().parentNode.innerHTML;
    const blob = new Blob([html], { type: 'image/svg+xml' });
    file_saver_1.default.saveAs(blob, 'sankey_diagram.svg');
    svg.style('border', '2px solid #d3d3d3');
    svg.select('#grid').style('opacity', '1');
};
const clickSavePDF = (data) => {
    const svg = window.d3.select(' .opensankey#svg-container svg');
    svg.selectAll('.sankey-tooltip').remove();
    svg.selectAll('text[visibility=hidden]').remove();
    svg.style('border', '0px');
    svg.select('#grid').style('opacity', '0');
    svg.attr('viewBox', [0, 0, data.width, data.height]);
    const html = svg.attr('title', 'test2')
        .attr('version', 1.1)
        .attr('xmlns', 'http://www.w3.org/2000/svg')
        .node().parentNode.innerHTML;
    svg.style('border', '2px solid #d3d3d3');
    svg.select('#grid').style('opacity', '1');
    const blob = new Blob([html], { type: 'image/svg+xml' });
    const form_data = new FormData();
    form_data.append('svg', blob);
    const path = window.location.href;
    let url = path + '/opensankey/sankey/save_pdf';
    const fetchData = {
        method: 'POST',
        body: form_data
    };
    const showFile = (blob) => {
        const newBlob = new Blob([blob], { type: 'application/pdf' });
        file_saver_1.default.saveAs(newBlob, 'sankey_diagram.pdf');
    };
    const cleanFile = () => {
        const fetchData = {
            method: 'POST'
        };
        url = path + '/opensankey/sankey/clean_pdf';
        fetch(url, fetchData);
    };
    fetch(url, fetchData).then(r => r.blob())
        .then(showFile).then(cleanFile);
};
const clickSavePNG = (data) => {
    const svg = window.d3.select(' .opensankey#svg-container svg');
    svg.selectAll('.sankey-tooltip').remove();
    svg.selectAll('text[visibility=hidden]').remove();
    svg.style('border', '0px');
    svg.select('#grid').style('opacity', '0');
    svg.attr('viewBox', [0, 0, data.width, data.height]);
    const html = svg.attr('title', 'test2')
        .attr('version', 1.1)
        .attr('xmlns', 'http://www.w3.org/2000/svg')
        .node().parentNode.innerHTML;
    svg.style('border', '2px solid #d3d3d3');
    svg.select('#grid').style('opacity', '1');
    const blob = new Blob([html], { type: 'image/svg+xml' });
    const form_data = new FormData();
    form_data.append('svg', blob);
    const path = window.location.href;
    let url = path + '/opensankey/sankey/save_png';
    const fetchData = {
        method: 'POST',
        body: form_data
    };
    const showFile = (blob) => {
        const newBlob = new Blob([blob], { type: 'application/png' });
        file_saver_1.default.saveAs(newBlob, 'sankey_diagram.png');
    };
    const cleanFile = () => {
        const fetchData = {
            method: 'POST'
        };
        url = path + '/opensankey/sankey/clean_png';
        fetch(url, fetchData);
    };
    fetch(url, fetchData).then(r => r.blob())
        .then(showFile).then(cleanFile);
};
const goToUserDoc = () => {
    const path = window.location.href;
    const url = path + 'doc';
    fetch(url, {
        method: 'GET'
    }).then((response) => {
        if (response.redirected) {
            return window.open(response.url, '_blank');
        }
    }).then(win => win === null || win === void 0 ? void 0 : win.focus());
};
const OpenSankeyMenus = (t, setShowPreference, reinitialization, default_sankey_data, set_show_publish_dialog, set_show_apply_layout, set_show_excel_dialog, set_show_save_json, showStyleEdition, showStyleEditionLink, set_show_welcome, set_never_see_again, data, set_data, url_prefix, set_show_modalTemplate, external_edition_item, externale_save_item, set_user_scale) => {
    const _load_json = react_1.useRef(null);
    return [
        react_1.default.createElement(react_bootstrap_1.NavDropdown, { key: 'files', title: t('Menu.Fichiers'), id: 'files' },
            react_1.default.createElement(react_bootstrap_1.NavDropdown, { drop: 'end', id: 'ouvrir', title: t('Menu.ouvrir') },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                        if (_load_json.current) {
                            _load_json.current.name = '';
                            _load_json.current.click();
                        }
                    } }, "JSON"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", ref: _load_json, style: { display: 'none' }, onChange: (evt) => {
                        const files = evt.target.files;
                        const reader = new FileReader();
                        reader.onload = (() => {
                            return (e) => {
                                reinitialization();
                                let result = String(e.target.result);
                                const new_data = default_sankey_data();
                                result = result.split('<br>').join('\\\\n');
                                const result_data = JSON.parse(result);
                                Object.assign(new_data, result_data);
                                if (result_data.version === undefined) {
                                    new_data.version = undefined;
                                }
                                SankeyConvert_1.convert_data(new_data);
                                SankeyConvert_1.complete_sankey_data(new_data, default_sankey_data, SankeyUtils_1.default_node, SankeyUtils_1.default_link);
                                SankeyUtils_1.set_nodes_level(data);
                                set_user_scale(new_data.user_scale);
                                set_data(new_data);
                                const test = document.getElementsByClassName('navbar');
                                let margin_top = 0;
                                if (test && test.length > 0) {
                                    margin_top = test[0].getBoundingClientRect().height;
                                    d3.select(' .opensankey #svg-container').style('margin-top', margin_top + 'px');
                                }
                            };
                        })();
                        reader.readAsText(files[0]);
                    } }),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => set_show_excel_dialog(true) }, "Excel")),
            react_1.default.createElement(react_bootstrap_1.NavDropdown, { drop: 'end', id: 'enregistrer', title: t('Menu.enregistrer') },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                        set_show_save_json(true);
                    } }, "JSON"),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => SankeyUtils_1.clickSaveExcel('/opensankey/', data) }, "Excel"),
                externale_save_item),
            react_1.default.createElement(react_bootstrap_1.NavDropdown, { drop: 'end', id: 'exporter', title: t('Menu.exporter') },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: clickSaveSVG },
                    t('Menu.exporter'),
                    " SVG"),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => clickSavePDF(data) },
                    t('Menu.exporter'),
                    " PDF"),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => clickSavePNG(data) },
                    t('Menu.exporter'),
                    " PNG")),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => { setShowPreference(true); } }, t('Menu.preference')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => { set_show_modalTemplate(true); } }, t('Menu.templates'))),
        react_1.default.createElement(react_bootstrap_1.NavDropdown, { key: 'edition', id: 'edition', title: t('Menu.Edition') },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: reinitialization }, t('Menu.reinit')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => set_show_apply_layout(true) }, t('Menu.amp')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: showStyleEdition }, t('Menu.esn')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: showStyleEditionLink }, t('Menu.esf')),
            external_edition_item),
        react_1.default.createElement(react_bootstrap_1.NavDropdown, { key: 'Aide', id: 'Aide', title: t('Menu.Aide') },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    set_show_welcome(true);
                    set_never_see_again(false);
                    localStorage.setItem('dontSeeAggainWelcome', '0');
                } }, t('DisplayWelcome')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => goToUserDoc() }, t('Menu.doc'))),
    ];
};
exports.OpenSankeyMenus = OpenSankeyMenus;
/**
 * Description placeholder
 *
 * @param {{ data: any; set_data: any;right_menu: any; settings_edition: any; settings_edition_node_tags: any; settings_edition_link_tags: any; settings_edition_data_tags: any; ... 39 more ...; launch: any; }}
 *
 * @returns
 */
const Menu = ({ t, data, set_data, default_sankey_data, nav_item_active, show_nav, set_show_nav, logo, logo_terriflux, logo_width, app_name, button_ref, accordion_ref, selected_node, url_prefix, callback, show_load, set_show_load, processing, setProcessing, failure, setFailure, not_started, setNotStarted, result, setResult, path, launch, configurations_menus, show_excel_dialog, set_show_excel_dialog, show_apply_layout, set_show_apply_layout, show_save_json, set_show_save_json, menus, set_welcome_text, show_modalTemplate, set_show_modalTemplate, cardsTemplate, token, useNavigate, external_modal, menu_banner, loginOut, unsetTokens, min_width_and_height, set_user_scale, name_user }) => {
    var _a, _b;
    let max_link_value = 0;
    Object.values(data.links).forEach(link => {
        const new_max_link_value = SankeyUtils_1.findMaxLinkValue(max_link_value, link.value);
        max_link_value = new_max_link_value > max_link_value ? new_max_link_value : max_link_value;
    });
    max_link_value += 1;
    if (not_started == false && processing == false) {
        const path = window.location.href;
        const url = path + url_prefix + 'loads_retrieves_result';
        const form_data = new FormData();
        const fetchData = {
            method: 'POST',
            body: form_data
        };
        fetch(url, fetchData).then(response => {
            response.text().then(text => {
                try {
                    const server_data = JSON.parse(text);
                    if (data.layout) {
                        server_data.layout = data.layout;
                    }
                    const new_data = Object.assign(default_sankey_data(), SankeyUtils_1.processExample(server_data));
                    callback(new_data);
                    delete new_data.layout;
                    set_user_scale(new_data.user_scale);
                    set_data(Object.assign({}, new_data));
                    //set_show_load(false)
                }
                catch (err) {
                    alert(err);
                }
            });
        });
        setProcessing(false);
        setFailure(false);
        setNotStarted(true);
    }
    //Switch the variable value that handle opening and closing the configuration menu
    const toggleShow = () => {
        var _a, _b, _c;
        set_show_nav(!show_nav);
        if (!show_nav) {
            // Lors de l'ouverture du menu, enregistre l'échelle de la zone de sankey 
            // et la position des scroll bar 
            const scaleOfSVG = d3.select(' .opensankey #svg').attr('transform').split(' ').filter(s => s.includes('scale'))[0].replace('scale(', '').replace(')', '');
            sessionStorage.setItem('scale', scaleOfSVG);
            const SL = (_a = document.getElementsByTagName('html')[0]) === null || _a === void 0 ? void 0 : _a.scrollLeft;
            const string_SL = (SL !== undefined) ? SL.toString() : 'none';
            sessionStorage.setItem('scrollLeft', string_SL);
            const ST = (_b = document.getElementsByTagName('html')[0]) === null || _b === void 0 ? void 0 : _b.scrollTop;
            const string_ST = (ST !== undefined) ? ST.toString() : 'none';
            sessionStorage.setItem('scrollTop', string_ST);
            SankeyUtils_2.adjust_sankey_zone(data, min_width_and_height, true);
        }
        else {
            // Lors de la fermeture du menu, remet l'échelle de la zone de sankey avant l'ouverture du menu
            // et replace la position des scroll bar comme elles etaient avant
            const scaleToUse = sessionStorage.getItem('scale');
            const SlToUse = sessionStorage.getItem('scrollLeft');
            const StToUse = sessionStorage.getItem('scrollTop');
            if (scaleToUse) {
                d3.select(' .opensankey #svg').attr('transform', 'translate(0,0) scale(' + scaleToUse + ')');
            }
            else {
                SankeyUtils_2.adjust_sankey_zone(data, min_width_and_height);
            }
            if (SlToUse && StToUse) {
                (_c = document.getElementsByTagName('html')[0]) === null || _c === void 0 ? void 0 : _c.scrollTo(+SlToUse, +StToUse);
            }
            sessionStorage.removeItem('scale');
            sessionStorage.removeItem('scrollLeft');
            sessionStorage.removeItem('scrollTop');
        }
    };
    const setChecked = react_1.useState(false)[1];
    let node = data.nodes[selected_node.current.idNode];
    if (node === undefined) {
        node = SankeyUtils_1.default_node(data);
    }
    const props = {
        scroll: true,
        backdrop: false,
    };
    const menuButton = () => {
        if (show_nav) {
            return react_1.default.createElement(fa_1.FaAngleDoubleRight, { style: { marginTop: '50px' } });
        }
        else {
            return react_1.default.createElement(fa_1.FaAngleDoubleLeft, { style: { marginTop: '50px' } });
        }
    };
    const has_scrollbar_shift = window.innerWidth - document.getElementsByTagName('html')[0].clientWidth;
    const navigate = useNavigate();
    const returnToApp = () => {
        navigate('/');
        set_data(Object.assign({}, data));
    };
    const toolbar = Object.values(menu_banner).map((c, i) => { return react_1.default.createElement(react_1.default.Fragment, { key: i }, c); });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        external_modal.map((c, i) => { return react_1.default.createElement(react_1.default.Fragment, { key: i }, c); }),
        react_1.default.createElement(react_bootstrap_1.Navbar, { className: 'bg-light', fixed: 'top', style: { 'display': 'block' } },
            react_1.default.createElement(react_bootstrap_1.Container, { className: 'MenuNavigation' },
                !window.SankeyToolsStatic ? react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Navbar.Brand, { style: { marginRight: '0px' }, href: "https://terriflux.com/" },
                        react_1.default.createElement("img", { src: logo_terriflux, width: 100 }),
                        " "),
                    react_1.default.createElement("div", { style: { display: 'inline-block', width: '0px', marginLeft: '5px', marginRight: '5px', height: '40px', borderRight: 'solid 1px #ddd', borderLeft: 'solid 1px #ddd', padding: '0' } })) : react_1.default.createElement(react_1.default.Fragment, null),
                react_1.default.createElement(react_bootstrap_1.Navbar.Brand, { href: "#", onClick: () => set_welcome_text(window.sankey.welcome_text) },
                    react_1.default.createElement("img", { src: logo, width: logo_width ? logo_width : 200 }),
                    " "),
                !window.SankeyToolsStatic ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Nav, { className: 'me-auto' }, menus.map((c, i) => {
                        return react_1.default.createElement(react_1.default.Fragment, { key: i }, c);
                    })),
                    toolbar,
                    react_1.default.createElement(react_bootstrap_1.Nav, null,
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Button, { style: { 'marginRight': '15px', 'width': '35px', 'height': '35px', 'backgroundColor': (!token) ? '#ff7851' : '#78c2ad', 'borderColor': (!token) ? '#ff7851' : '#78c2ad' }, onClick: () => (token) ? navigate('/dashboard') : navigate('/login') },
                                react_1.default.createElement(fa_1.FaUser, null)),
                            react_1.default.createElement(react_bootstrap_1.Form.Label, { style: { display: 'contents' } }, (token) ? name_user : t('connect')),
                            token ? react_1.default.createElement(react_bootstrap_1.Button, { style: { 'marginRight': '15px', 'width': '35px', 'height': '35px' }, variant: 'danger', onClick: () => loginOut(unsetTokens, returnToApp) },
                                react_1.default.createElement(fa_1.FaPowerOff, null)) : react_1.default.createElement(react_1.default.Fragment, null))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement("h4", { onClick: () => set_welcome_text(window.sankey.welcome_text) },
                            react_1.default.createElement("a", { href: "#", style: { color: "#666" } }, window.sankey.header))),
                    toolbar)))),
        react_1.default.createElement(react_bootstrap_1.Navbar, { bg: 'light', fixed: 'bottom', style: { fontSize: '0.85em' } },
            react_1.default.createElement(react_bootstrap_1.Container, { className: 'sankeyFooter' },
                react_1.default.createElement("span", { style: { display: 'inline' } },
                    "\u00A9",
                    react_1.default.createElement("a", { href: "https://terriflux.com/" },
                        react_1.default.createElement("img", { width: 75, src: logo_terriflux })),
                    " - Tous droits r\u00E9serv\u00E9s"),
                react_1.default.createElement("span", { style: { display: 'inline' } }, app_name),
                react_1.default.createElement("span", { style: { display: 'inline' } },
                    react_1.default.createElement("a", { href: 'https://terriflux.com/mentions-legales/' }, "Mention l\u00E9gales")),
                react_1.default.createElement("span", { style: { display: 'inline' } }, "9 rue du Rocher de Lorzier, 38430 Moirans  +33 (0)6 21 83 56 76"))),
        (!data.static_sankey) ? react_1.default.createElement(react_bootstrap_1.Offcanvas, Object.assign({ className: 'sankey-menu', show: show_nav, placement: 'end' /*onHide={set_show_nav(false)}*/ }, props, { style: { 'width': '540px', 'marginTop': ((_a = document.getElementsByClassName('MenuNavigation')[0]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().y) + ((_b = document.getElementsByClassName('MenuNavigation')[0]) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) } }),
            react_1.default.createElement(react_bootstrap_1.Offcanvas.Body, { style: { 'padding': '0px 0px 0px 0px' } },
                react_1.default.createElement(SankeyMenuConfiguration_1.SankeyConfigurationMenu, { nav_item_active: nav_item_active, accordion_ref: accordion_ref, configuration_menus: configurations_menus })))
            : react_1.default.createElement(react_1.default.Fragment, null),
        !data.static_sankey ? (react_1.default.createElement(react_bootstrap_1.ToggleButton, { style: { 'width': '40px', height: '120px', position: 'fixed', top: window.innerHeight / 2, left: window.innerWidth - 40 - ((show_nav) ? 540 + has_scrollbar_shift : has_scrollbar_shift), zIndex: 100 }, ref: button_ref, id: "toggle-check", type: "checkbox", variant: "outline-primary", checked: show_nav, onChange: (e) => { setChecked(e.currentTarget.checked); }, onClick: toggleShow, value: "menuConfigButton" }, menuButton())) : (react_1.default.createElement(react_1.default.Fragment, null)),
        processing ? (react_1.default.createElement(react_bootstrap_1.Modal.Dialog, null,
            react_1.default.createElement(react_bootstrap_1.Button, { className: "btn btn-sm btn-warning col-md-12" },
                react_1.default.createElement("span", { className: "glyphicon glyphicon-refresh glyphicon-refresh-animate" }),
                " Processing..."))) : (react_1.default.createElement(react_1.default.Fragment, null)),
        react_1.default.createElement(SankeyMenuDialogs_1.ApplySaveJSONDialog, { t: t, show_save_json: show_save_json, set_show_save_json: set_show_save_json, sankey_data: data, set_sankey_data: set_data }),
        react_1.default.createElement(SankeyMenuDialogs_1.ApplyLayoutDialog, { t: t, show_apply_layout: show_apply_layout, set_show_apply_layout: set_show_apply_layout, sankey_data: data, set_sankey_data: set_data }),
        react_1.default.createElement(SankeyMenuDialogs_1.ExcelModal, { t: t, launch: launch, handleCloseDialog: () => set_show_excel_dialog(false), uploadExcelImpl: SankeyUtils_1.uploadExcelImpl, set_data: set_data, data: data, show_excel_dialog: show_excel_dialog, set_show_excel_dialog: set_show_excel_dialog, url_prefix: url_prefix, callback: callback }),
        react_1.default.createElement(SankeyLoad_1.default, { url_prefix: url_prefix, successAction: () => SankeyUtils_2.downloadExamples(path, url_prefix, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'), show_dialog: show_load, set_show_dialog: set_show_load, processing: processing, setProcessing: setProcessing, failure: failure, setFailure: setFailure, setNotStarted: setNotStarted, result: result, setResult: setResult }),
        // {modalTemplate}
        react_1.default.createElement(react_bootstrap_1.Modal, { size: 'xl', show: show_modalTemplate, onHide: () => set_show_modalTemplate(false) },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true }, t('Banner.sdr')),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement(react_bootstrap_1.Row, { md: 4 }, cardsTemplate)))));
};
Menu.propTypes = MenuPropTypes;
exports.default = Menu;
const OpenSankeyModalShortcut = (t, showShortcut, setshowShortcut, additional_shortcut_item) => {
    return react_1.default.createElement(react_bootstrap_1.Modal, { size: 'lg', show: showShortcut, onHide: () => setshowShortcut(false) },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, t('Menu.rc'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement("h4", { style: { textAlign: 'center' } }, "Raccourcis de l'application OpenSankey"),
            react_1.default.createElement("h5", null, "Avec la souris en mode s\u00E9lection :"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Click (noeuds) :"),
                " S\u00E9lectionne le noeud cliqu\u00E9"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "CTRL + Click (noeuds) :"),
                " S\u00E9lectionne le noeud cliqu\u00E9 et ouvre l'onglet \"",
                react_1.default.createElement("b", null, "Noeuds"),
                "\" du menu"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Click (flux) :"),
                " S\u00E9lectionne le flux cliqu\u00E9"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "CTRL + Click (flux) :"),
                " S\u00E9lectionne le flux cliqu\u00E9 et ouvre l'onglet \"",
                react_1.default.createElement("b", null, "Flux"),
                "\" du menu"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Click (en dehors d'un noeud/flux) :"),
                "  D\u00E9s\u00E9lectionne les noeuds et flux s\u00E9lectionn\u00E9s"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Click droit (noeuds) :"),
                "  Agr\u00E9ge le noeud"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Alt Click droit (noeuds) :"),
                "  D\u00E9sagr\u00E9ge le noeud"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Alt + Drag (label noeuds) :"),
                "  D\u00E9place le label"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Shift + survole (noeuds) :"),
                "  Affiche la valeur des flux entrant et sortant du noeud dans une tooltip"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Shift + survole (flux) :"),
                "  Affiche la valeur du flux dans une tooltip "),
            react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }),
            react_1.default.createElement("h5", null, "Avec la souris en mode \u00E9dition :"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Click (zone de dessin) :"),
                " Ajoute un noeud \u00E0 l'endroit cliqu\u00E9"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Drag (\u00E0 partir de la zone de dessin) :"),
                " Cr\u00E9e un noeud au point de d\u00E9part du drag puis cr\u00E9e un flux partir du noeud cr\u00E9e vers : soit un noeud d\u00E9j\u00E0 existant si l'on drop dessus, soit cr\u00E9e un noeud si l'on drop sur la zone de dessin "),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Drag (\u00E0 partir d'un noeud) :"),
                " Cr\u00E9er un flux partir du  noeud de d\u00E9part du drag vers : soit un noeud d\u00E9j\u00E0 existant si l'on drop dessus, soit cr\u00E9e un noeud si l'on drop sur la zone de dessin  "),
            react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }),
            react_1.default.createElement("h5", null, "Autres raccourcis :"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Suppr :"),
                " Supprime les noeuds et flux s\u00E9lectionn\u00E9s"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Fl\u00E8che du clavier :"),
                " Permet de d\u00E9placer les noeuds s\u00E9lectionn\u00E9s en fonction du grillage  "),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Drag (bouton du milieu de la souris et en dehors d'un noeud/flux)"),
                " Permet de d\u00E9placer le sankey complet  "),
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Echap :"),
                " Ferme le Menu si il est ouvert et remet la fonction de la souris en tant que s\u00E9lecteur "),
            additional_shortcut_item),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => setshowShortcut(false) }, "Close")));
};
exports.OpenSankeyModalShortcut = OpenSankeyModalShortcut;
const OpenSankeyModalWelcome = (t, active_page, set_active_page, show_modal_welcome, set_show_modal_welcome, never_see_again, set_never_see_again, additional_shortcut_item, external_pagination, external_content, exemple_menu) => {
    const content_rc = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h4", { style: { textAlign: 'center' } }, "Raccourcis de l'application OpenSankey"),
        react_1.default.createElement("h5", null, "Avec la souris en mode s\u00E9lection :"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Click (noeuds) :"),
            " S\u00E9lectionne le noeud cliqu\u00E9"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "CTRL + Click (noeuds) :"),
            " S\u00E9lectionne le noeud cliqu\u00E9 et ouvre l'onglet \"",
            react_1.default.createElement("b", null, "Noeuds"),
            "\" du menu"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Click (flux) :"),
            " S\u00E9lectionne le flux cliqu\u00E9"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "CTRL + Click (flux) :"),
            " S\u00E9lectionne le flux cliqu\u00E9 et ouvre l'onglet \"",
            react_1.default.createElement("b", null, "Flux"),
            "\" du menu"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Click (en dehors d'un noeud/flux) :"),
            "  D\u00E9s\u00E9lectionne les noeuds et flux s\u00E9lectionn\u00E9s"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Click droit (noeuds) :"),
            "  Agr\u00E9ge le noeud"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Alt Click droit (noeuds) :"),
            "  D\u00E9sagr\u00E9ge le noeud"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Alt Drag (label noeuds) :"),
            "  D\u00E9place le label"),
        react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }),
        react_1.default.createElement("h5", null, "Avec la souris en mode \u00E9dition :"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Click (zone de dessin) :"),
            " Ajoute un noeud \u00E0 l'endroit cliqu\u00E9"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Drag (\u00E0 partir de la zone de dessin) :"),
            " Cr\u00E9e un noeud au point de d\u00E9part du drag puis cr\u00E9e un flux \u00E0 partir du noeud cr\u00E9e vers : soit un noeud d\u00E9j\u00E0 existant si l'on drop dessus, soit un noeud que l'on cr\u00E9e \u00E0 l'endroit o\u00F9 l'on drop sur la zone de dessin"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Drag (\u00E0 partir d'un noeud) :"),
            " Cr\u00E9er un flux \u00E0 partir du  noeud de d\u00E9part du drag vers : soit un noeud d\u00E9j\u00E0 existant si l'on drop dessus, soit un noeud que l'on cr\u00E9e \u00E0 l'endroit o\u00F9 l'on drop sur la zone de dessin  "),
        react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }),
        react_1.default.createElement("h5", null, "Autres raccourcis :"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Suppr :"),
            " Supprime les noeuds et flux s\u00E9lectionn\u00E9s"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Fl\u00E8che du clavier :"),
            " Permet de d\u00E9placer les noeuds s\u00E9lectionn\u00E9s en fonction du grillage  "),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Drag (bouton du milieu de la souris et en dehors d'un noeud/flux)"),
            " Permet de d\u00E9placer le sankey complet  "),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Echap :"),
            " Ferme le Menu quand il est ouvert et remet la fonction de la souris en tant que s\u00E9lecteur "),
        additional_shortcut_item);
    external_content['rc'] = content_rc;
    const tmp = JSON.parse(JSON.stringify(exemple_menu));
    let list_template_data = [];
    // Si exemple_menu contient OpenSankey et que ce sous dossier contient les templates simple alors remple la liste des templates avec les modèle simples
    if (Object.keys(tmp).length !== 0 && Object.keys(tmp).includes('OpenSankey') && Object.keys(tmp['OpenSankey']).includes('easy_template')) {
        list_template_data = tmp['OpenSankey']['easy_template'].filter((f) => !f.includes('.xlsx'));
        // Si l'un des sous dossier d'OpenSankey dans exemple_menu est expert_template alors ajoute les modèles expert à la liste des modèles
        if (Object.keys(tmp['OpenSankey']).includes('expert_template')) {
            list_template_data.push(tmp['OpenSankey']['expert_template']);
            list_template_data = list_template_data.flat();
        }
    }
    const content_carousel = react_1.default.createElement(react_bootstrap_1.Carousel, { variant: 'dark' }, list_template_data.map((_, idx) => {
        const title = _.split('.').splice(0, 1).join('');
        return (react_1.default.createElement(react_bootstrap_1.Carousel.Item, null,
            react_1.default.createElement("img", { src: '/fm/userfiles/OpenSankey/image_preview/' + title + '.png', style: { 'objectFit': 'contain', 'width': '100%', 'height': '650px', display: 'inline-block' } }),
            react_1.default.createElement(react_bootstrap_1.Carousel.Caption, { style: { display: 'inline-block' } },
                react_1.default.createElement("p", null, title.replaceAll('_', ' ')))));
    }));
    external_content['carousel'] = content_carousel;
    return react_1.default.createElement(react_bootstrap_1.Modal, { scrollable: true, size: 'xl', show: show_modal_welcome && !never_see_again, onHide: () => {
            set_show_modal_welcome(false);
        } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, t('welcome.welcome'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null, external_content[active_page]),
        window.SankeyToolsStatic ? react_1.default.createElement(react_1.default.Fragment, null) : react_1.default.createElement(react_bootstrap_1.Modal.Footer, { style: { justifyContent: 'center' } },
            react_1.default.createElement(react_bootstrap_1.Pagination, null,
                external_pagination.map((c, i) => { return react_1.default.createElement(react_1.default.Fragment, { key: i }, c); }),
                react_1.default.createElement(react_bootstrap_1.Pagination.Item, { active: active_page === 'carousel', key: 'carousel', onClick: () => {
                        set_active_page('carousel');
                    } }, "Exemples"),
                react_1.default.createElement(react_bootstrap_1.Pagination.Item, { active: active_page === 'rc', key: 'rc', onClick: () => {
                        set_active_page('rc');
                    } }, t('Menu.rc'))),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: t('dontSeeAgain'), checked: never_see_again, onChange: evt => {
                    set_never_see_again(evt.target.checked);
                    localStorage.setItem('dontSeeAggainWelcome', '1');
                } })));
};
exports.OpenSankeyModalWelcome = OpenSankeyModalWelcome;
